interface FeaturedCityInfo {
  isHidden?: boolean;
  hasAppartmentLink?: boolean;
  hasRoomLink?: boolean;
}

const FeaturedCities: { [cityName: string]: FeaturedCityInfo } = {
  'Chapel Hill': { isHidden: true },
  Liège: { isHidden: true },
  Guadalajara: { isHidden: true },
  Tilburg: { isHidden: true },
  Bern: { isHidden: true },
  Lille: { isHidden: true },
  Turin: { isHidden: false },
  Salamanca: { isHidden: true },
  Murcia: { isHidden: true },
  Siena: { isHidden: true },
  Groningen: { isHidden: true },
  Hamburg: { isHidden: false, hasAppartmentLink: true, hasRoomLink: true },
  London: { hasAppartmentLink: true, hasRoomLink: true },
  'Los Angeles': { hasAppartmentLink: true },
  Amsterdam: { hasAppartmentLink: true, hasRoomLink: true },
  Barcelona: { hasAppartmentLink: true, hasRoomLink: true },
  Dublin: { hasAppartmentLink: true, hasRoomLink: true },
  Rome: { hasAppartmentLink: true, hasRoomLink: true },
  Berkeley: { hasAppartmentLink: true },
  Valencia: { hasAppartmentLink: true },
  Berlin: { hasAppartmentLink: true },
  Prague: { hasAppartmentLink: true },
  Florence: { hasAppartmentLink: true },
  Madrid: { hasAppartmentLink: true },
  Lisbon: { hasAppartmentLink: true },
  Milan: { hasAppartmentLink: true },
  Columbus: { hasAppartmentLink: true },
  Copenhagen: { hasAppartmentLink: true },
  Vienna: { hasAppartmentLink: true },
  Córdoba: { hasAppartmentLink: true, hasRoomLink: true },
  Munich: { hasAppartmentLink: true },
  Shanghai: { hasAppartmentLink: true },
  Athens: { hasAppartmentLink: true },
  Sevilla: { hasAppartmentLink: true },
  Stockholm: { hasAppartmentLink: true, hasRoomLink: true },
  Rotterdam: { hasAppartmentLink: true },
  Granada: { hasAppartmentLink: true },
  Brussels: { hasAppartmentLink: true },
  Bordeaux: { hasAppartmentLink: true },
  Helsinki: { hasAppartmentLink: true },
  Lyon: { hasAppartmentLink: true },
  Utrecht: { hasAppartmentLink: true },
  Ljubljana: { hasAppartmentLink: true },
  'The Hague': { hasAppartmentLink: true },
  Bologna: { hasAppartmentLink: true },
};

export default FeaturedCities;
